var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23047 7.92278H13.3074C13.5535 7.92278 13.7689 7.70739 13.7689 7.46124V6.53816C13.7689 6.29201 13.5535 6.07662 13.3074 6.07662H8.23047C8.04585 6.07662 7.92278 5.95355 7.92278 5.76893V0.692007C7.92278 0.445853 7.70739 0.230469 7.46124 0.230469H6.53816C6.29201 0.230469 6.07662 0.445853 6.07662 0.692007V5.76893C6.07662 5.95355 5.95355 6.07662 5.76893 6.07662H0.692007C0.445853 6.07662 0.230469 6.29201 0.230469 6.53816V7.46124C0.230469 7.70739 0.445853 7.92278 0.692007 7.92278H5.76893C5.95355 7.92278 6.07662 8.04585 6.07662 8.23047V13.3074C6.07662 13.5535 6.29201 13.7689 6.53816 13.7689H7.46124C7.70739 13.7689 7.92278 13.5535 7.92278 13.3074V8.23047C7.92278 8.04585 8.04585 7.92278 8.23047 7.92278Z",
    fill: "#C8172F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRed);
export default __webpack_public_path__ + "static/media/plus_red.ac7230376781af869dda927d52428332.svg";
export { ForwardRef as ReactComponent };